import Repository from './Repository';

const resource = "/messages";
export default {
    all() {
        return Repository.get(`${resource}/`);
    },
    get(id) {
        return Repository.get(`${resource}/${id}/`);
    },
}